export const handleChangeFirstLogin = () => {
    return {
        type:'CHANGE_STATUS',
    }
}
export const resetFirstLogin = () => {
    return {
        type:'RESET_STATUS',
    }
}